import { Button } from 'component/Button'
import { Gap } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { LoadingPage } from 'page/LoadingPage'
import { Page } from 'page/Page/Page'
import { controller } from 'store/controller'
import { me } from 'store/me'
import { store } from 'store/store'

export const GenerationsEmptyScreen = observer(() => {
  const product = !!store.item
  const { initialized, tab } = store.inferences

  const onBack = useLatestCallback(() => {
    controller.openStart()
  })

  if (me.user_id && !initialized) return <LoadingPage start />

  if (tab === 'fav')
    return (
      <Page center>
        <Typo size={14} center>
          {i18n('YouHaveNoFavoriteOutfitsYet')}
        </Typo>
      </Page>
    )

  if (!product)
    return (
      <Page center>
        <Typo size={14} center>
          {i18n('YouHaveNoCreatedOutfitsYet')}
        </Typo>
        <Gap height={20} />
        <Typo size={14} center>
          {i18n('SelectItemToCreateAnOutfit')}
        </Typo>
      </Page>
    )

  return (
    <Page center>
      <Typo size={14} center>
        {i18n('YouHaveNoCreatedOutfitsYet')}
      </Typo>
      {product && <Gap height={40} />}
      {product && (
        <Button large primary action={onBack}>
          {i18n('ProceedToCreateAnOutfit')}
        </Button>
      )}
    </Page>
  )
})
